import React from "react";
import { getYoutubeId, getVimeoId, getMatterportId } from "@wrstudios/utils";
import { Container } from "./styled/tour";
function Tour(_a) {
    var _b = _a.virtualTour, virtualTour = _b === void 0 ? "" : _b, _c = _a.backgroundColor, backgroundColor = _c === void 0 ? "#eeeff1" : _c;
    var youtubeId = getYoutubeId(virtualTour);
    var _d = getVimeoId(virtualTour).split("-"), parentId = _d[0], vimeoId = _d[1];
    var matterportId = getMatterportId(virtualTour);
    return (React.createElement(Container, { backgroundColor: backgroundColor },
        youtubeId && (React.createElement("iframe", { title: "Youtube Video", src: "https://www.youtube.com/embed/" + youtubeId, allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true })),
        vimeoId && (React.createElement("iframe", { title: "Vimeo Video", src: parentId
                ? "https://player.vimeo.com/video/" + parentId + "?h=" + vimeoId
                : "https://player.vimeo.com/video/" + vimeoId, allow: "autoplay; fullscreen", allowFullScreen: true })),
        matterportId && (React.createElement("iframe", { title: "Matterport 3d Tour", src: "https://my.matterport.com/show/?m=" + matterportId, allow: "xr-spatial-tracking", allowFullScreen: true }))));
}
export default Tour;
